<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
>
  @if (entity.id) {
    <pr-button-confirm
      top-right-action
      display="danger"
      icon="delete_outline"
      (onConfirm)="doneSubject.next(); postDeleteMessage()"
      comment="Toute suppression est definitive, les données seront perdues."
      labelConfirm="Supprimer"
      labelCancel="Annuler"
    >
      Êtes-vous sûr(e) de vouloir supprimer <em>“{{ entity.label }}”</em>
    </pr-button-confirm>
  }

  <input formControlName="id" type="hidden" />
  <pr-tabs
    clazz="drawer-tab-button"
    [defaultTextColor]="false"
    [defaultTextColor]="false"
    [changeTab]="changeTab"
    (lastTab)="onTabChange($event)"
  >
    <pr-tab label="Informations générales">
      <h3 class="drawer-title">Informations du bien</h3>
      @if (canConvertType) {
        <div class="type-switch">
          <span class="type-switch-hint"
            >Ce bien est en {{ currentTypeLabel }}. Les Loyers,les charges,et
            les crédits sont conservés en cas de changement.</span
          >
          <pr-button-confirm
            display="neutral"
            variant="outline"
            size="lg"
            [label]="'Passer en ' + targetTypeLabel"
            [disabled]="converting"
            title="Changement de type de bien"
            labelConfirm="Changer le type"
            labelCancel="Annuler"
            (onConfirm)="convertType()"
          >
            <p>
              Êtes-vous sûr de vouloir passer ce bien de
              <b>{{ currentTypeLabel }}</b> en <b>{{ targetTypeLabel }}</b
              >&nbsp;?
            </p>
            <div class="law-select">
              <pr-input label="Régime fiscal">
                <mat-select
                  [value]="conversionFiscalLaw"
                  placeholder="Choisir le régime"
                  (selectionChange)="conversionFiscalLaw = $event.value"
                >
                  @for (law of conversionLaws; track law.key) {
                    <mat-option [value]="law.key">
                      {{ 'api.' + law.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </pr-input>
            </div>
          </pr-button-confirm>
        </div>
      }
      <div class="form-sct-container">
        <ea-realestate-form
          [entity]="entity"
          [derrors]="derrors"
          [isGMaps]="isGMaps"
        ></ea-realestate-form>

        <div formGroupName="fiscalLaw">
          <pr-input label="Type de fiscalité" [derrors]="derrors">
            <mat-select formControlName="type">
              @for (fiscalLaw of fiscalLaws; track fiscalLaw) {
                <mat-option [value]="fiscalLaw">
                  {{ 'api.' + fiscalLaw.label | translate }}
                </mat-option>
              }
            </mat-select>
          </pr-input>

          <pr-input-autosuggest
            formControlName="subscriptionPartner"
            label="Promoteur / Fournisseur"
            [options]="lawPartners"
            [derrors]="derrors"
            [optionLabel]="'name'"
            [hidden]="!form.get('fiscalLaw.type').value"
            [loading]="lawPartners.length == 0"
          >
            <span customOptionText
              >Ce fournisseur sera créé lors de l'enregistrement.</span
            >
          </pr-input-autosuggest>

          <pr-input-date
            formControlName="startDate"
            label="Première location"
            [hidden]="!form.get('fiscalLaw.type').value?.hasFirstDate"
            [derrors]="derrors"
          ></pr-input-date>

          @if (form.get('fiscalLaw.type').value?.durationYear) {
            <pr-input
              [label]="durationLabel(form.get('fiscalLaw.type').value.key)"
              [derrors]="derrors"
            >
              <mat-select formControlName="duration" [compareWith]="compareFn">
                @for (
                  duration of form.get('fiscalLaw.type').value.durationYear;
                  track duration
                ) {
                  <mat-option [value]="duration">
                    {{ duration + ' an' + (duration > 1 ? 's' : '') }}
                  </mat-option>
                }
              </mat-select>
            </pr-input>
          }
        </div>
        <ea-estate-loan-form
          [entity]="entity"
          [derrors]="derrors"
        ></ea-estate-loan-form>
      </div>
    </pr-tab>
    <pr-tab label="Loyers">
      <h3 class="drawer-title">Loyers perçus</h3>
      <div class="form-sct-container">
        <ea-rent-form [entity]="entity" [derrors]="derrors"></ea-rent-form>
      </div>
    </pr-tab>
    <pr-tab label="Charges">
      <h3 class="drawer-title">Charges</h3>
      <div class="form-sct-container">
        <ea-fees-form [entity]="entity" [derrors]="derrors"></ea-fees-form>
      </div>
    </pr-tab>
    <pr-tab label="Valorisations">
      <h3 class="drawer-title">Valorisations</h3>
      <div class="form-sct-container">
        <ea-estimation-form
          [entity]="entity"
          [derrors]="derrors"
        ></ea-estimation-form>
      </div>
    </pr-tab>
    <pr-tab label="Détention">
      <h3 class="drawer-title">Informations sur la détention</h3>
      <div class="form-sct-container">
        <pr-input
          label="Type de résidence"
          [derrors]="derrors"
          [hidden]="
            form &&
            ['LAND', 'SURFACE', 'GARAGE'].includes(form.value.personalUseType)
          "
        >
          <mat-select formControlName="residenceType">
            <mat-option value="APPARTMENT">{{
              'pages.realEstate.appartment' | translate
            }}</mat-option>
            <mat-option value="HOUSE">{{
              'pages.realEstate.house' | translate
            }}</mat-option>
          </mat-select>
        </pr-input>

        <pr-input label="Acquis au travers de" [derrors]="derrors">
          <mat-select formControlName="subscriptionSource">
            @for (item of subscriptionSource; track item) {
              <mat-option [value]="item.id">
                {{ item.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-owner-share
          formControlName="owners"
          [derrors]="derrors"
        ></pr-input-owner-share>
      </div>
    </pr-tab>
  </pr-tabs>
</pr-form>
